import { CardType } from 'Prototype/Level/Card/CardType';
import { ICardModifierData } from 'Prototype/Level/Card/ICardModifierData';
import { IGameState } from 'State/Game/IGameState';
import CardStateHelper from '../CardStateHelper';
import { ICardsState, ICardStateData } from '../ICardState';
import TimerModifierBehavior from './TimerModifierBehavior';
import { isLevelCompletedSuccessfully } from "State/Level/LevelStateHelper";
import { StopSound } from 'System/Audio/AudioHelper';

export default class TNTModifierBehavior extends TimerModifierBehavior {
    /**
     * Called for each modifier after an in-play card is matched.
     * @param state Card state reference.
     * @param matchedCardID The ID of the card triggering this update.
     */
    public onCardMatched(state: IGameState, matchedCardID: string): IGameState {
        const matchedCardStateData = CardStateHelper.getCardStateData(state, matchedCardID);

        if (matchedCardID === this.cardID) {
            StopSound('tnt_8_moves_Left');
        }

        if (
            // Only affected by value and gold type cards
          (matchedCardStateData.type !== CardType.gold &&
          matchedCardStateData.type !== CardType.value) ||
            // Not affected if the modifiers card was the one matched
            matchedCardID === this.cardID ||
            // Not affected if level is complete
            isLevelCompletedSuccessfully(state.levelState) ||
            // Not affected if invalid update
            !this.validateUpdate(state.levelState.cardsState)
        ) return state;

        return this.setTimer(state, this.modifier.properties.timer - 1);
    }

    /**
     * Called for each modifier after a card is folded.
     * @param state Card state reference.
     * @param sourceCardID The ID of the card triggering this update.
     */
    public onCardFolded(state: IGameState, sourceCardID: string): IGameState {
        if (!this.validateUpdate(state.levelState.cardsState)) return state;

        return this.setTimer(state, this.modifier.properties.timer - 1);
    }

    public onUndoUsed(state: IGameState, prevCardState: ICardStateData, prevModifier: ICardModifierData): IGameState {
        if (!this.validateUpdate(state.levelState.cardsState)) return state;

        state = this.setTimer(state, prevModifier.properties.timer);

        return state;
    }

    protected validateUpdate(state: ICardsState): boolean {
        return super.validateUpdate(state) && state.turns !== 0;
    }
}
